// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3L-ia","imageUploader":"EGiftCard_imageUploader__FHWk8"};